import React from 'react';
import { makeStyles } from '@material-ui/core';
import EntryContainer from './Components/EntryContainer';
import data from './data/faq.json';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    background: '#fff',
    minHeight: '100vh'
  },
  content: {
    flexGrow: 1,
    padding: '60px 24px 24px 24px',
    width: 'calc(100% - 240px)'
  },
}));


const App = () => {
  const classes = useStyles();
  const faqs = data.faqs;



  return (
    <div className={classes.root}>
      <Router>
        <Switch>
          <Route exact path={'/'} >
            <Redirect to={`${faqs[0].slug}${faqs[0].subFaqs[0].slug}`} />
          </Route>
          <Route path={`/:parentslug/:childslug?`}>
            <EntryContainer faqs={faqs} />
          </Route>
        </Switch>
      </Router>
    </div>

  )
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js